import { css } from "styled-components";

export const centralizadoVerticalmente = css`
  display: inline-flex;
  align-items: center;
`;